<template>
  <div class="body container">
    <!--导航-->
    <div class="nav clearfix">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :stretch="true" label="全部" name="0"></el-tab-pane>
        <el-tab-pane
          :stretch="true"
          :label="column.name"
          :name="column.id.toString()"
          v-for="column in brotherColumnData"
          :key="column.id"
        ></el-tab-pane>
      </el-tabs>
    </div>

    <!--筛选-->
    <div class="selectWrap">
      <h4 class="tip">筛选</h4>
      <div class="selectBox">
        <div class="common">
          <span class="text">学段:</span>
          <div class="common-box">
            <a
              style="cursor: pointer"
              :class="{ active: -1 == section_index }"
              @click="selectSection(-1, 0)"
              >全部</a
            >
            <a
              style="cursor: pointer"
              v-for="(item, index) in sectionData"
              :class="{ active: index == section_index }"
              :key="item.section_id"
              @click="selectSection(index, item.section_id)"
              >{{ item.section_name }}</a
            >
          </div>
        </div>
        <div class="common">
          <span class="text">时间:</span>
          <div class="common-box">
            <div class="select-box">
              <el-select
                v-model="year"
                placeholder="学年"
                @change="getArticleData"
              >
                <el-option
                  v-for="year in yearListData"
                  :value="year.key"
                  :key="year.key"
                  :label="year.value"
                ></el-option>
              </el-select>

              <el-select
                v-model="term"
                placeholder="学期"
                @change="getArticleData"
              >
                <el-option value="0" label="学期"></el-option>
                <el-option value="1" label="上学期"></el-option>
                <el-option value="2" label="下学期"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--文章资源-->
    <div class="content wrapper clearfix">
      <div class="resourceBox fl" :style="videoWidth()">
        <div class="sortBox clearfix">
          <div class="sort fl">
            <a
              :class="{ active: orderby == 0 }"
              @click="articleSort(0)"
              style="cursor: pointer"
              >时间排序</a
            >
            <a
              :class="{ active: orderby == 1 }"
              @click="articleSort(1)"
              style="cursor: pointer"
              >点击量排序</a
            >
          </div>
          <div class="searchBox fr">
            <span class="des">
              共
              <span>{{ recordcount }}</span> 条结果
            </span>
            <div>
              <el-input
                class="search keyword"
                v-model="keyword"
                placeholder="标题关键字"
                @keyup.enter.native="getArticleData"
              ></el-input>

              <a class="searchBtn" @click="getArticleData"></a>
            </div>
          </div>
        </div>

        <ul class="resource" v-if="!(type == 405)">
          <li
            style="padding: 10px 0"
            class="resourceList"
            v-for="article in articleData"
            :key="article.id"
            @click="
              toArticleInfo(article.id, article.open_scope, article.schoolid)
            "
          >
            <div class="title">
              <a style="cursor: pointer">{{ article.title }}</a>
              <span class="time">
                <i></i>
                <em>{{ article.create_time }}</em>
              </span>
            </div>
            <div class="intro">{{ article.content }}</div>
            <div class="infoBox">
              <span>
                <img :src="article.userface" :alt="article.username" />
                {{ article.username }}
              </span>
              <span>{{ typeArray[article.type - 1] }}</span>
              <span>
                <i class="heartIcon"></i>
                <em>{{ article.open_scope == 1 ? "公开" : "本校" }}</em>
              </span>
              <span>
                <i class="eyeIcon"></i>
                <em>{{ article.view_count }}</em>
              </span>
            </div>
          </li>
        </ul>
        <ul class="video clearfix" v-if="type == 405">
          <li
            class="videoList"
            v-for="article in articleData"
            :key="article.id"
          >
            <div
              class="cover"
              @click="
                toArticleInfo(article.id, article.open_scope, article.schoolid)
              "
            >
              <img
                :src="article.logo_resid"
                :alt="article.title"
                :onerror="errorImg"
              />
            </div>
            <div class="videoInfo">
              <div
                style="font-size: 14px"
                class="title"
                title="15"
                @click="
                  toArticleInfo(
                    article.id,
                    article.open_scope,
                    article.schoolid
                  )
                "
              >
                {{ article.title }}
              </div>
              <div>
                <span class="auth" style="float: left">
                  <i></i>
                  <em>{{ article.permission_scope == 1 ? "公开" : "本校" }}</em>
                </span>
                <span class="num" style="float: right">
                  <i></i>
                  <em>{{ article.view_count }}</em>
                </span>
                <br />
                <span class="username" style="float: left">
                  <i></i>
                  <em>{{ article.username }}</em>
                </span>
              </div>
            </div>
          </li>
        </ul>
        <div class="noData" v-if="type == 405 && nodata">
          <img src="../../assets/img/no_video.png" />
          <p>暂无学习资源，去别的地方看看吧~</p>
        </div>
        <div class="noData" v-if="!(type == 405) && nodata">
          <img src="../../assets/img/no_article.png" />
          <p>暂无文章类型资源，去别的地方看看吧~</p>
        </div>
      </div>
    </div>
    <div class="btnGroup">
      <div class="pagination">
        <el-pagination
          background
          hide-on-single-page
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="recordcount"
          :current-page="page"
          :page-size="type == 405 ? pagesize : pagesize2"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import { type } from "os";
export default {
  name: "new_edu",
  data() {
    return {
      errorImg: 'this.src="' + require("../../assets/img/onliveDf.png") + '"', // 图片损坏默认图
      nodata: false,
      columnid: "",
      orderby: "0",
      brotherColumnData: [],
      articleData: [],
      keyword: "",
      page: 1,
      pagesize: 24, // 视频分页
      pagesize2: 10, // 文章分页
      recordcount: 0,
      sectionData: [], //学段数组
      section_id: 0, //当前学段
      section_index: -1, //学段索引
      yearListData: [],
      year: 0,
      term: "",
      hotData: [],
      typeArray: [
        "书香校园",
        "共写随笔",
        "窗外声音",
        "卓越口才",
        "理想课堂",
        "数码社区",
        "每月一事",
        "完美教室",
        "卓越课程",
        "合作共建",
      ],

      type: "",
      activeName: "",
    };
  },

  components: {},

  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },

  watch: {
    $route() {
      //监控$route
      this.type = this.$route.query.id;
      this.activeName = this.type;
      this.school_id = this.$route.query.schoolid;
      // this.type = this.columnid.slice(2);
      this.getArticleData();
      // this.getBrotherColumns();
      this.getYearList();
      this.getSectionList();
      // this.updateTitle();
    },
    globalVaranthasInited: function () {
      this.init();
    },
  },

  created() {
    this.type = this.$route.query.id;
    this.activeName = this.type;
    this.school_id = this.$route.query.schoolid;
  },

  methods: {
    init() {
      this.type = this.$route.query.id;
      this.activeName = this.type;
      this.school_id = this.$route.query.schoolid;
      this.getNewEduType();
      // this.type = this.columnid.slice(2);
      this.getArticleData();
      // this.getBrotherColumns();
      this.getYearList();
      this.getSectionList();
      // this.updateTitle();
    },
    //获取二级栏目列表
    // async getBrotherColumns() {
    //   let data = {
    //     s: "WebSchoolSpace.NewEducation.GetArticleTypes"
    //   };
    //   let res = await globalApi.post( data);

    //   this.brotherColumnData = res.data.data;
    // },

    //获取新教育栏目列表
    async getNewEduType() {
      let data = {
        s: "WebSchoolSpace.NewEducation.getTypeList",
        type_of: 4,
        web_level: 1,
        org_id: this.school_id,
        inc_disabled: 0,
      };
      let res = await globalApi.post(data);
      this.brotherColumnData = res.data.data.list;
    },

    //获取当前栏目数据
    async getArticleData() {
      var pagesize = this.columnid == 605 ? this.pagesize : this.pagesize2;
      document.documentElement.scrollTop = 0;
      let data = {
        s: "WebSchoolSpace.NewEducation.SearchArticle",
        // columnid: this.columnid,
        // weblevel: this.weblevel,
        type: this.type,
        page: this.page,
        page_size: pagesize,
        keyword: this.keyword,
        order_by: this.orderby,
        school_year: this.year,
        term: this.term,
        section: this.section_id,
        schoolid: this.school_id,
      };
      let res = await globalApi.post(data);
      // console.log(res);

      if (res.data.ret == 200 && res.data.data.result == 1) {
        this.recordcount = res.data.data.recordcount;
        this.articleData = res.data.data.list;
        // let articleData = res.data.data.list;
        // this.articleData = articleData;
        this.nodata = this.recordcount ? false : true;
      } else {
        this.$message.error(res.data.msg);
      }
    },

    //获取学段列表
    async getSectionList() {
      let data = {
        s: "WebSchoolSpace.Common.GetSection",
      };

      let res = await globalApi.post(data);
      this.sectionData = res.data.data;
    },
    //选择学段
    selectSection(index, id) {
      this.page = 1;
      this.section_index = index;
      this.section_id = id;
      this.getArticleData();
    },
    //获取学年列表
    async getYearList() {
      let data = {
        s: "WebSchoolSpace.Common.GetYearList",
      };

      let res = await globalApi.post(data);
      this.yearListData = res.data.data;
    },

    //跳转至文章详情
    async toArticleInfo(article_id, power, schoolid) {
      const powers = globalApi.checkViewPower(power, schoolid);

      if (powers == 2) {
        let fromurl = encodeURIComponent(location.href);
        location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
        return false;
      }
      if (powers == 3) {
        this.$message.error("无访问权限!");
        return false;
      }
      // this.addViewCount(article_id);
      globalApi.jumpPath(
        2,
        "school_newedu_info",
        "&id=" +
          article_id +
          "&columnid=" +
          this.type +
          "&schoolid=" +
          this.$route.query.schoolid
      );
    },

    handleClick() {
      this.page = 1;
      const type_id = this.activeName;
      this.type = type_id;
      this.getArticleData();
    },

    //切换二级栏目
    changeColumn(id) {
      this.page = 1;
      this.$router.push(
        String(
          "school_newedu" +
            "?id=" +
            id +
            "&schoolid=" +
            this.$route.query.schoolid
        )
      );
      this.type = id;
    },
    //文章排序
    articleSort(index) {
      this.page = 1;
      this.orderby = index;
      this.getArticleData();
    },
    // 分页导航
    handleCurrentChange(val) {
      this.page = val;
      this.getArticleData();
    },

    //视频栏目列表样式调整
    videoWidth() {
      if (this.columnid == 605) {
        return "width:100%;";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
.video .videoList .videoInfo {
  padding: 3px 10px !important;
}
.select-box .el-select {
  margin-right: 20px;
}
.keyword {
  width: 90%;
}
</style>
<style scoped>
.nav >>> .el-tabs__nav-wrap::after {
  height: 0px;
}
.nav >>> .el-tabs__active-bar {
  height: 0px;
}
.selectWrap {
  margin-top: 0px !important;
}
</style>